import { Fragment } from 'react';
import { getProductTagClassName } from '../../utils/ProductTagUtils';

const APP_TAG_PATTERN = /:([^:]+):/g;

export const parseDescriptionWithTags = (text) => {
    const normalizedText = String(text ?? '');
    const tags = Array.from(normalizedText.matchAll(APP_TAG_PATTERN))
        .map((match) => String(match[1] ?? '').trim())
        .filter(Boolean);
    const cleanedText = normalizedText
        .replace(APP_TAG_PATTERN, ' ')
        .replace(/\s+([,.;!?])/g, '$1')
        .replace(/\s+/g, ' ')
        .trim();

    return {
        text: cleanedText,
        tags,
    };
};

export default function DescriptionWithTags({ text, fallback = 'No description provided.' }) {
    const content = String(text ?? '').trim() || fallback;
    const { text: descriptionText, tags } = parseDescriptionWithTags(content);

    return (
        <>
            {descriptionText ? <Fragment>{descriptionText}</Fragment> : null}
            {tags.length > 0 ? (
                <span className="description-with-tags__apps">
                    <span className="description-with-tags__apps-label">Applications included:</span>
                    <span className="description-with-tags__apps-list">
                        {tags.map((tag, index) => (
                            <span key={`tag-${index}`} className={getProductTagClassName(tag)}>
                                {tag}
                            </span>
                        ))}
                    </span>
                </span>
            ) : null}
        </>
    );
}
